export default __webpack_public_path__ + "static/media/grandmaAndLady2.8863f51b.jpg";